"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var VideoLogEvent_1 = require("../statscollector/VideoLogEvent");

var BaseTask_1 = require("./BaseTask");
/*
 * [[AttachMediaInputTask]] adds audio and video input to peer connection.
 */


var AttachMediaInputTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(AttachMediaInputTask, _BaseTask_1$default);

  var _super = _createSuper(AttachMediaInputTask);

  function AttachMediaInputTask(context) {
    var _this;

    _classCallCheck(this, AttachMediaInputTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'AttachMediaInputTask';
    return _this;
  }

  _createClass(AttachMediaInputTask, [{
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var transceiverController, audioInput, audioTracks, senders, videoInput, videoTracks, videoTrack, encodingParam, _senders;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                transceiverController = this.context.transceiverController;
                transceiverController.setPeer(this.context.peer);
                transceiverController.setupLocalTransceivers();
                audioInput = this.context.activeAudioInput;

                if (!audioInput) {
                  _context.next = 17;
                  break;
                }

                audioTracks = audioInput.getAudioTracks();

                if (!this.context.browserBehavior.requiresUnifiedPlan()) {
                  _context.next = 12;
                  break;
                }

                this.context.logger.info('attaching audio track to peer connection (unified-plan)');
                _context.next = 10;
                return transceiverController.setAudioInput(audioTracks.length ? audioTracks[0] : null);

              case 10:
                _context.next = 15;
                break;

              case 12:
                this.context.logger.info('attaching audio track to peer connection (plan-b)'); // @ts-ignore

                senders = this.context.peer.getSenders();
                audioInput.getAudioTracks().forEach(function (track) {
                  if (!senders.find(function (sender) {
                    return sender.track.id === track.id;
                  })) {
                    // unclear why this does not deal with the case of removing
                    // an existing track as we do in attachVideoInput
                    // @ts-ignore
                    _this2.context.localAudioSender = _this2.context.peer.addTrack(track, audioInput);
                  }
                });

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.next = 19;
                return transceiverController.setAudioInput(null);

              case 19:
                this.context.logger.info('no audio track');

              case 20:
                videoInput = this.context.activeVideoInput;

                if (!videoInput) {
                  _context.next = 37;
                  break;
                }

                videoTracks = videoInput.getVideoTracks();
                videoTrack = videoTracks.length ? videoTracks[0] : null;

                if (!this.context.browserBehavior.requiresUnifiedPlan()) {
                  _context.next = 31;
                  break;
                }

                this.context.logger.info('attaching video track to peer connection (unified-plan)');
                _context.next = 28;
                return transceiverController.setVideoInput(videoTrack);

              case 28:
                if (this.context.enableSimulcast && this.context.videoUplinkBandwidthPolicy) {
                  encodingParam = this.context.videoUplinkBandwidthPolicy.chooseEncodingParameters();
                  transceiverController.setEncodingParameters(encodingParam);
                }

                _context.next = 34;
                break;

              case 31:
                this.context.logger.info('attaching video track to peer connection (plan-b)'); // @ts-ignore

                _senders = this.context.peer.getSenders();

                if (!_senders.find(function (sender) {
                  return sender.track && sender.track.id === videoTracks[0].id;
                })) {
                  if (this.context.localVideoSender) {
                    // @ts-ignore
                    this.context.peer.removeTrack(this.context.localVideoSender);
                    this.context.localVideoSender = null;
                  }

                  this.context.localVideoSender = this.context.peer.addTrack(videoTracks[0], videoInput);
                }

              case 34:
                if (videoTrack) {
                  this.context.statsCollector.logVideoEvent(VideoLogEvent_1.default.InputAttached, this.context.videoDeviceInformation);
                  this.context.videoInputAttachedTimestampMs = Date.now();
                }

                _context.next = 41;
                break;

              case 37:
                _context.next = 39;
                return transceiverController.setVideoInput(null);

              case 39:
                this.context.logger.info('no video track');

                if (this.context.localVideoSender) {
                  this.context.logger.info('removing track from peer'); // @ts-ignore

                  this.context.peer.removeTrack(this.context.localVideoSender);
                  this.context.localVideoSender = null;
                }

              case 41:
                this.context.videoSubscriptions = transceiverController.updateVideoTransceivers(this.context.videoStreamIndex, this.context.videosToReceive);

              case 42:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return AttachMediaInputTask;
}(BaseTask_1.default);

exports.default = AttachMediaInputTask;